export default [
  {
    title: 'Reports Menu',
    icon: 'FileTextIcon',
    name:'dashboard',
    tagVariant: 'light-warning',
    children: [

      {
        title: 'Services Summary Report',
        name: 'reports.services-summary',
        route: 'reports.services-summary',
        icon: 'FileTextIcon',
        meta: {
          module: 'reports.services-summary'
        }
      },

      {
        title: 'Geofence trip Report',
        name: 'reports.geofenceTrip',
        route: 'reports.geofenceTrip',
        icon: 'FileTextIcon',
        meta: {
          module: 'reports.geofenceTrip'
        }
      },
  {
    title: 'Geofence Report',
    name: 'reports.geofence',
    route: 'reports.geofence',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.geofence'
    }
  },
  {
    title: 'RFID Dump Report',
    name: 'reports.rfidContainerDump',
    route: 'reports.rfidContainerDump',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.rfidContainerDump'
    }
  },


  {
    title: 'Reader Plan Report',
    name: 'reports.readerDumpPlan',
    route: 'reports.readerDumpPlan',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.readerDumpPlan'
    }
  },

  {
    title: 'Washer Plan Report',
    name: 'reports.washerPlan',
    route: 'reports.washerPlan',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.washerPlan'
    }
  },
  {
    title: 'Wash RFID Plan Report',
    name: 'reports.containerWashRfidPlan',
    route: 'reports.containerWashRfidPlan',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.containerWashRfidPlan'
    }
  },

  {
    title: 'Container Lift (PTO)',
    name: 'reports.PTO',
    route: 'reports.PTO',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.PTO'
    }
  },

    {
      title: 'Sweeper Service',
      name: 'reports.WhsSweep',
      route: 'reports.WhsSweep',
      icon: 'FileTextIcon',
      meta: {
        module: 'reports.WhsSweep'
      }
    },
  {
    title: 'CONTAINER_WASH_PLAN_REPORT_TITLE',
    name: 'reports.containerWashPlan',
    route: 'reports.containerWashPlan',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.containerWashPlan'
    }
  },
  {
    title: 'CONTAINER_AREA_PLAN_REPORT_TITLE',
    name: 'reports.containerAreaPlan',
    route: 'reports.containerAreaPlan',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.containerAreaPlan'
    }
  },
  {
    title: 'Status Report',
    name: 'reports.status',
    route: 'reports.status',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.status'
    }
  },

  {
    title: 'Garden Report',
    name: 'reports.garden',
    route: 'reports.garden',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.garden'
    }
  },

  {
    title: 'Garden Plan Report',
    name: 'reports.gGarden',
    route: 'reports.gGarden',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.gGarden'
    }
  },

  {
    title: 'Compactor Report',
    name: 'reports.compactor',
    route: 'reports.compactor',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.compactor'
    }
  },

  {
    title: 'Trip Report',
    name: 'reports.trip',
    route: 'reports.trip',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.trip'
    }
  },
  {
    title: 'Absence Report',
    name: 'reports.absence',
    route: 'reports.absence',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.absence'
    }
  },

  // {
  //   title: 'SweepPlan Report',
  //   name: 'reports.sweepPlan',
  //   route: 'reports.sweepPlan',
  //   icon: 'FileTextIcon',
  //   meta: {
  //     module: 'reports.sweepPlan'
  //   }
  // },

      {
        title: 'SweepPlan Report 2',
        name: 'reports.sweepPlan',
        route: 'reports.sweepPlan',
        icon: 'FileTextIcon',
        meta: {
          module: 'reports.sweepPlan'
        }
      },

  {
    title: 'Container Plan Report',
    name: 'reports.containerPlan',
    route: 'reports.containerPlan',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.containerPlan'
    }
  },

  {
    title: 'Sweep Report',
    name: 'reports.sweep',
    route: 'reports.sweep',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.sweep'
    }
  },

  {
    title: 'Container Service Report',
    name: 'reports.containerService',
    route: 'reports.containerService',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.containerService'
    }
  },

  {
    title: 'Non Lifted Containers Report',
    name: 'reports.nonLiftedContainers',
    route: 'reports.nonLiftedContainers',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.nonLiftedContainers'
    }
  },


  {
    title: 'History  Report',
    name: 'reports.history',
    route: 'reports.history',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.history'
    }
  },
  {
    title: 'Support Devices  Report',
    name: 'reports.supportDevices',
    route: 'reports.supportDevices',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.supportDevices'
    }
  },
  {
    title: 'Fill Area Report',
    name: 'reports.fillAreas',
    route: 'reports.fillAreas',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.fillAreas'
    }
  },
  {
    title: 'Forbidden Areas Report',
    name: 'reports.forbiddenAreas',
    route: 'reports.forbiddenAreas',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.forbiddenAreas'
    }
  },
  {
    title: 'Landfill Areas Report',
    name: 'reports.landFillAreas',
    route: 'reports.landFillAreas',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.landFillAreas'
    }
  },

  {
    title: 'Support Compactor',
    name: 'reports.supportCompactor',
    route:'reports.supportCompactor',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.supportCompactor'
    }
  },
  {
    title: 'Drainage Plan Report',
    name: 'reports.drainage',
    route:'reports.drainage',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.drainage'
    }
  },
  {
    title: 'Rain Plan Report',
    name: 'reports.rainPlan',
    route:'reports.rainPlan',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.rainPlan'
    }
  },

  {
    title: 'Network Plans Report',
    name: 'reports.network',
    route:'reports.network',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.network'
    }
  },

  {
    title: 'Utility Report',
    name: 'reports.utility',
    route:'reports.utility',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.utility'
    }
  },
  {
    title: 'Distance Report',
    name: 'reports.distance',
    route:'reports.distance',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.distance'
    }
  },
  {
    title: 'Pest Control Report',
    name: 'reports.pestControl',
    route:'reports.pestControl',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.pestControl'
    }
  },
  {
    title: 'Support Center Report',
    name: 'reports.supportCenter',
    route:'reports.supportCenter',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.supportCenter'
    }
  },

  {
    title: 'Total Absence Monthly Report',
    name:  'reports.totalAbsencePerMonth',
    route: 'reports.totalAbsencePerMonth',
    icon: 'FileTextIcon',
    meta: {
      module: 'reports.totalAbsencePerMonth',
    }
  },
  {
    title: 'Devices Absence PerMonth',
    name:   'reports.devicesAbsenceCountPerMonth',
    route:  'reports.devicesAbsenceCountPerMonth',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.devicesAbsenceCountPerMonth',
    }
  },
  {
    title: 'Dump Plan By Stops',
    name:   'reports.dumpPlanByStops',
    route:  'reports.dumpPlanByStops',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.dumpPlanByStops',
    }
  },
  {
    title: 'Container Pest Plan Report',
    name:   'reports.containerPestPlan',
    route:  'reports.containerPestPlan',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.containerPestPlan',
    }
  },
  {
    title: 'Container Pest Plan Summary Report',
    name:   'reports.containerPestPlanSummary',
    route:  'reports.containerPestPlanSummary',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.containerPestPlanSummary',
    }
  },
  {
    title: 'Container Pest Plan Comprehensive Report',
    name:   'reports.containerPestPlanComprehensive',
    route:  'reports.containerPestPlanComprehensive',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.containerPestPlanComprehensive',
    }
  },

  {
    title: 'Control Pest Report',
    name:   'reports.controlPest',
    route:  'reports.controlPest',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.controlPest',
    }
  },

  {
    title: 'Work Time & Duration Report',
    name:   'reports.routeDistance',
    route:  'reports.routeDistance',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.routeDistance',
    }
  },
  
  {
    title: 'Total Absence PerDay Report',
    name:   'reports.absenceGenerated',
    route:  'reports.absenceGenerated',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.absenceGenerated',
    }
  },
  {
    title: 'Overspeed Report',
    name:   'reports.overspeed',
    route:  'reports.overspeed',
    icon: 'FileTextIcon',
    meta: {
      module:  'reports.overspeed',
    }
  }
]
}
]
